import './highlight.css';
import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';
import { useEffect, useState } from 'react';
import csvIcon from '../images/csv-icon.png';

export default function HighlightOfTheDay() {
  // State for multiple tables
  const [tables, setTables] = useState(() => {
    const savedTables = JSON.parse(localStorage.getItem('highlightTables'));
    return (
      savedTables || [
        {
          id: 1,
          title: 'January',
          texts: Array(31).fill(''),
        },
      ]
    );
  });

  const BackgroundColors = [
    '#FFEBEE',
    '#FCE4EC',
    '#F3E5F5',
    '#EDE7F6',
    '#E3F2FD',
    '#E1F5FE',
    '#E0F7FA',
    '#E0F2F1',
    '#E8F5E9',
    '#F1F8E9',
    '#FFFDE7',
    '#FFF8E1',
    '#FFF3E0',
    '#FBE9E7',
    '#EFEBE9',
    '#FAFAFA',
    '#F5F5F5',
    '#ECEFF1',
    '#E3F2FD',
    '#E1F5FE',
    '#E8EAF6',
    '#EDE7F6',
    '#F3E5F5',
    '#FCE4EC',
    '#FFEBEE',
    '#FFF3E0',
    '#FFF8E1',
    '#FFFDE7',
    '#F1F8E9',
    '#E8F5E9',
    '#E0F7FA',
  ];

  useEffect(() => {
    localStorage.setItem('highlightTables', JSON.stringify(tables));
  }, [tables]);

  const handleTextChange = (tableId, day, value) => {
    setTables((prevTables) =>
      prevTables.map((table) =>
        table.id === tableId
          ? {
              ...table,
              texts: table.texts.map((text, i) => (i === day ? value : text)),
            }
          : table,
      ),
    );
  };

  const addNewTable = () => {
    const newTable = {
      id: tables.length + 1,
      title: `Month ${tables.length + 1}`,
      texts: Array(31).fill(''),
    };
    setTables([newTable, ...tables]); // Add new table at the beginning
  };

  const updateTableTitle = (tableId, newTitle) => {
    setTables((prevTables) =>
      prevTables.map((table) =>
        table.id === tableId ? { ...table, title: newTitle } : table,
      ),
    );
  };

  const exportToCSV = () => {
    const data = [];
    tables.forEach((table) => {
      table.texts.forEach((text, dayIndex) => {
        if (text) {
          data.push({
            Day: dayIndex + 1,
            Month: table.title,
            Text: text,
          });
        }
      });
    });
    const csv = unparse(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'table-data.csv');
  };

  return (
    <div>
      <div className="header-highlights">
        <h1>The Daily Highlights</h1>
        <ol>
          <li>Type in the month.</li>
          <li>Type in your highlight of the day.</li>
          <li>Type in the month.</li>
          <li>(If you want you can also download the data as csv.)</li>
        </ol>
      </div>

      {tables.map((table) => (
        <div key={table.id} className="table-container">
          <input
            type="text"
            value={table.title}
            onChange={(e) => updateTableTitle(table.id, e.target.value)}
            className="table-title-input"
          />
          <table>
            <thead>
              <tr>
                <th>Day</th>
                <th>Highlights</th>
              </tr>
            </thead>
            <tbody>
              {table.texts.map((text, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="highlights-cell">
                    <textarea
                      style={{
                        background: BackgroundColors[index],
                      }}
                      typeof="text"
                      className="highlights-field"
                      value={text}
                      onChange={(e) =>
                        handleTextChange(table.id, index, e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            <button onClick={addNewTable} className="add-table-btn">
              Add New Month
            </button>
          </div>
        </div>
      ))}
      <div className="csv-container">
        <button onClick={exportToCSV} className="csv-button">
          <img src={csvIcon} className="csv-icon" />
          Download Highlights
        </button>
      </div>
    </div>
  );
}
